export const ErrorMessage = {
  Name: "Name is Mandatory",
  Email: "Email is Mandatory",
  Password: "Password is Mandatory",
  ConfirmPassword: "Confirm Password is Mandatory",
  PhoneNumber: "Phone Number is Mandatory",
  MobileNumber: "Mobile Number is Mandatory",
  UserId: "User Id is Mandatory",
  Captcha: "Captcha is Mandetroy",
  MatchPassword: "password and confirm password not matched",
  ApplicationCategory: "application Category is Mandatory",
  ApplicationSubCategory: "application Sub Category is Mandatory",
  Number: "number is Mandatory",
  Valid: {
    Name: "Name is Invalid",
    RoleName: "Role Name is Invalid",
    Email: "Email is Invalid",
    Password: "Password is Invalid",
    ConfirmPassword: "Confirm Password is Invalid",
    PhoneNumber: "Phone Number is Invalid",
    MobileNumber: "Mobile Number is Invalid",
    AlternateNumber: "Alternate Number is Invalid",
    UserId: "User Id is Invalid",
    Captcha: "Captcha is Invalid",
    Number: "number is Invalid",
  },
  Invalid: {
    Formate: "Format is not valid"
  }
};

export const checkValidation = (
  value,
  fieldName,
  errorMessage,
  regex,
  formError,
  setFormError
) => {
  const updatedError = { ...formError };

  let statusName = `${fieldName}Status`;
  if (value === "") {
    updatedError[fieldName] = "";
    updatedError[statusName] = false;
  } else if (!value.match(regex)) {
    updatedError[fieldName] = errorMessage;
    updatedError[statusName] = true;
  } else {
    updatedError[fieldName] = "";
    updatedError[statusName] = false;
  }
  setFormError(updatedError);
};

export const ErrorMsg = ({ error }) => {
  let errMsg = error ? error : "";
  let formatMsg =
    errMsg &&
    (errMsg.charAt(0).toUpperCase() + errMsg.slice(1))
      .replace(/[A-Z]/g, " $&")
      .trim();
  return (
    <div className="error-message-style" >
      {formatMsg}
    </div>
  );
};